import img1 from "/public/img/slider_jardinerie/1.jpg";
import img2 from "/public/img/slider_jardinerie/2.jpg";
import img3 from "/public/img/slider_jardinerie/3.jpg";

export const images = [img1, img2, img3];
